export default "__VITE_ASSET__CvmBwx9J__"